import React from 'react';
import 'react-day-picker/dist/style.css';
import { DateRange } from 'react-day-picker';
import BaseCalendar from '../BaseCalendar';

const currentDate = new Date();

type Props = {
  range: DateRange | undefined;
  setRange: (r: DateRange | undefined) => void;
};

const RangeCalendar: React.FC<Props> = ({ range, setRange }) => (
  <BaseCalendar
    mode={'range'}
    min={2}
    defaultMonth={range?.to || range?.from || currentDate}
    selected={range}
    onSelect={setRange}
  />
);
export default RangeCalendar;
